import { IAppState } from 'models/store.model'
import { getStripePurchaseCommonEventParams } from 'modules/purchase/helpers/getStripePurchaseCommonEventParams'

export const getStripePurchaseStartedEventParams = (state: IAppState) => {
  const { productId, currentPrice, trialPeriodPrice, currency, screenName } =
    getStripePurchaseCommonEventParams(state)

  return {
    productId,
    priceDetails: {
      price: currentPrice,
      trial: !!trialPeriodPrice,
      currency,
    },
    screenName,
  }
}
